export const reportsSelectors = {
  reports: (state) => state.reports,
  update: (state) => state.update,
}
